// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "3adfad513c3a964aac0f" + "/js/" + chunkId + ".js";
};